<template>
	<div class="product-add" v-loading="loading">
		<div class="" style="display: flex; flex-direction: column;" :class="{ 'click-disabled': isDisabled }">
			<div class="top-head">
				<div class="user-top">
					<img :src="info.avatarUrl" alt="" style="width: 100px;height: 130px;" />
				</div>
				<div
					style="display: flex; flex-direction: column;justify-content: space-around;height: 130px;margin-left: 30px;">
					<div style="display: flex;align-items: center;">
						<i class="el-icon-coordinate" style="font-size: 16px;"></i>
						<h3>{{info.username}}</h3>
						<div class="" style="margin: 0px 20px;">/</div>
						<i class="el-icon-user" style="font-size: 16px;"></i>
						<h3>{{info.auth.id_card?'已认证':'未认证'}}</h3>
						<div class="" style="margin: 0px 20px;">/</div>
						<i :class="info.gender==1?'el-icon-female':'el-icon-male'" style="font-size: 16px;"></i>
						<h3>{{info.gender==1?'男':'女'}}</h3>
					</div>
					<div class="" style="display: flex; align-items: center;">
						<h2>
							<input ref="mobileInput" placeholder="" class="text-tel" maxlength="11"
								v-model="info.mobile" @blur="forceBlur" />
						</h2>
						<span style="color: gray;">（接单号码）</span>
						<span style="margin: 0px 50px;"></span>
						<h2>{{info.mobile}}</h2>
						<span style="color: gray;">（注册号码）</span>
					</div>
					<div class="" style="color: gray;">
						<span>注册：{{info.createTime}}</span>
						<!-- <span style="margin: 0px 50px;">推荐人：0</span>
						<span>推荐人（技师）：0</span> -->
					</div>
				</div>
			</div>
			<div class="" style="display: flex; align-items: center;justify-content: space-around;margin: 20px 0px;">
				<div class="tag-laber">
					<h3>余额</h3>
					<h3>{{info.money}}</h3>
				</div>
				<div class="tag-laber">
					<h3>评价</h3>
					<h3>{{statisticsList.total?statisticsList.total.score :0 }}</h3>
				</div>
				<div class="tag-laber">
					<h3>技师收益</h3>
					<h3>{{statisticsList.month?statisticsList.month.price :0 }}</h3>
				</div>
				<div class="tag-laber">
					<h3>服务时间</h3>
					<h3>{{statisticsList.today?statisticsList. today.serviceTime:0 }}</h3>
				</div>
				<div class="tag-laber">
					<h3>加钟订单</h3>
					<h3>{{statisticsList.today?statisticsList. today.clock_total :0}}</h3>
				</div>
				<div class="tag-laber">
					<h3>加钟金额</h3>
					<h3>{{statisticsList.today?statisticsList. today.clock_price :0}}</h3>
				</div>
				<div class="tag-laber">
					<h3>总订单量</h3>
					<h3>{{statisticsList.today?statisticsList.today.order_total:0 }}</h3>
				</div>
				<div class="tag-laber">
					<h3>总业绩</h3>
					<h3>{{statisticsList.today?statisticsList.today.order_price :0}}</h3>
				</div>
			</div>
		</div>

		<el-tabs v-model="activeName">
			<el-tab-pane label="基本信息" name="basic"></el-tab-pane>
			<el-tab-pane label="实名认证" name="idcard"></el-tab-pane>
			<el-tab-pane label="技师相册" name="waiterphoto"></el-tab-pane>
			<el-tab-pane label="技师介绍" name="introduce"></el-tab-pane>
			<el-tab-pane label="材料证明" name="occupation"></el-tab-pane>
			<!-- <el-tab-pane label="健康证明" name="health"></el-tab-pane> -->
			<el-tab-pane label="服务时间" name="timeservice"></el-tab-pane>
			<el-tab-pane label="服务项目" name="project"></el-tab-pane>
			<el-tab-pane label="服务区域" name="servicearea"></el-tab-pane>
			<el-tab-pane label="比例设置" name="setscale"></el-tab-pane>
		</el-tabs>
		<!--form表单-->
		<el-form size="small" ref="form" :model="form" label-width="180px"  :class="{ 'click-disabled': isDisabled }" v-if="loading1">
			<!--基础信息-->
			<Basic ref="userTel" v-show="activeName == 'basic'" :isDisabled="isDisabled"></Basic>
			<idcard v-show="activeName == 'idcard'"></idcard>
			<!--禁忌说明-->
			<waiterphoto v-show="activeName == 'waiterphoto'"></waiterphoto>
			<!--项目描述-->
			<introduce ref="userInfo" v-show="activeName == 'introduce'"></introduce>
			<!--  -->
			<occupation v-show="activeName == 'occupation'"></occupation>
			<!-- <health v-show="activeName == 'health'"></health> -->
			<timeservice v-show="activeName == 'timeservice'"></timeservice>
			<project v-show="activeName == 'project'"></project>
			<servicearea v-show="activeName == 'servicearea'"></servicearea>
			<setscale v-show="activeName == 'setscale'"></setscale>

		</el-form>
		<div class="common-button-wrapper" v-if="!isDisabled">
			<el-button size="small" type="info" @click="cancelFunc">取消</el-button>
			<el-button size="small" type="primary" @click="onSubmit('edit')" :disabled="save_loading">编辑</el-button>
		</div>
	</div>
</template>

<script>
	import Technician from "@/api/technician.js";
	import HeadframeApi from "@/api/headframe.js";
	import Basic from "./part/basic.vue";
	import waiterphoto from "./part/waiterphoto.vue";
	import introduce from "./part/introduce.vue";
	import occupation from "./part/occupation.vue";
	// import health from "./part/health.vue";
	import project from "./part/project.vue";
	import servicearea from "./part/servicearea.vue";
	import timeservice from "./part/timeservice.vue";
	import idcard from "./part/idcard.vue";
	import setscale from "./part/setscale.vue";

	import {
		formatModel
	} from "@/utils/base.js";
	export default {
		components: {
			/*基础信息*/
			Basic,
			idcard,
			/*规格信息*/
			waiterphoto,
			/*商品详情*/
			introduce,
			/*高级设置*/
			occupation,
			timeservice,
			// health,
			project,
			servicearea,
			setscale
		},
		data() {
			return {
				/*是否正在提交保存*/
				save_loading: false,
				activeName: "basic",
				loading: false,
				waiter_user_id: "",
				getdata: [],
				gender: "",
				loading1: false,
				labelList: [],
				form: {
					serviceTime_newarr: [],
					serviceTime: [],
					product_newselected: [], // 选中的服务项目id
					waiter: {
						tag: [],
						birthday: "",
						images: [],
						city_id: ""
					}
				},
				info: '', // 详情
				statisticsList: '' ,// 统计
				isDisabled: false
			};
		},
		provide: function() {
			return {
				form: this.form
			};
		},
		created() {
			this.waiter_user_id = this.$route.query.waiter_user_id;
			this.isDisabled = this.$route.query.scene == 'detail';
			this.$route.meta.title = `详情`;
			this.getData();
			this.getstatistics()
			this.getlabelData();
		},
		mounted() {},
		filters: {
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now();
				},
				shortcuts: [{
						text: "今天",
						onClick(picker) {
							picker.$emit("pick", new Date());
						}
					},
					{
						text: "昨天",
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24);
							picker.$emit("pick", date);
						}
					},
					{
						text: "一周前",
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit("pick", date);
						}
					}
				]
			}
		},
		methods: {
			//失去焦点
			forceBlur() {
				if (!this.info.mobile) {

				}
			},
			// 修改手机号是获取焦点
			focusInput() {
				this.$refs.mobileInput.focus();
			},
			btnUpload() {
				this.$refs.userInfo.abcImg()
			},
			// 统计
			getstatistics() {
				let self = this;
				let params = {};
				params.waiter_user_id = self.waiter_user_id
				Technician.statistics(params, true)
					.then(data => {
						self.statisticsList = data.data;
					})
					.catch(error => {});
			},
			/*取消*/
			cancelFunc() {
				this.$router.back(-1);
			},
			// 头衔
			getlabelData() {
				let self = this;
				HeadframeApi.getAlllabelList({}, true)
					.then(res => {
						self.labelList = res.data.list;
					})
					.catch(error => {
						self.loading = false;
					});
			},
			// 查询技师详情
			getData: function() {
				let self = this;
				Technician.getnewWaiterInfo({
						waiter_user_id: self.waiter_user_id
					}, true)
					.then(res => {
						self.loading1 = true;
						self.info = res.data.waiter
						console.log("self.info", self.info)
						Object.assign(self.form, res.data);
						self.form.product_list.forEach(item => {
							if (item.selected == "2") {
								self.form.product_newselected.push(item.product_id);
							}
						});
					})
					.catch(error => {
						self.loading = false;
					});
			},
			/*提交*/
			onSubmit: function(submit_type) {
				let self = this;
				console.log(self.form);
				self.$refs.form.validate(valid => {
					let param = formatModel(self.form);
					if (valid) {
						let param = formatModel(self.form);
						// param.tag = "";
						self.save_loading = true;
						Technician.waiteredit({
									waiter_user_id: self.waiter_user_id,
									param: JSON.stringify(param)
								},
								true
							)
							.then(data => {
								self.save_loading = false;
								self.$message({
									message: "保存成功",
									type: "success"
								});
								self.cancelFunc();
							})
							.catch(error => {
								self.save_loading = false;
							});
					} else {
						self.$message({
							message: "请检查必填项是否填写完整",
							type: "error"
						});
					}
				});
			}

			// 修改技师
			// onSubmit() {
			//   let self = this;
			//   let waiter_user_id = self.waiter_user_id;

			//   let username = self.getdata.username;
			//   let label_id = self.getdata.label_id;
			//   let gender = self.getdata.gender;
			//   let birthday = self.getdata.birthday;
			//   let height = self.getdata.height;
			//   let introduce = self.getdata.introduce;
			//   let nickName = self.getdata.nickName;
			//   let mobile = self.getdata.mobile;
			//   let working_hours = self.getdata.working_hours;
			//   let lng = self.getdata.lng;
			//   let lat = self.getdata.lat;
			//   Technician.editWaiter(
			//     {
			//       label_id,
			//       username,
			//       gender,
			//       birthday,
			//       height,
			//       introduce,
			//       nickName,
			//       mobile,
			//       working_hours,
			//       lng,
			//       lat,
			//       waiter_user_id
			//     },
			//     true
			//   )
			//     .then(res => {
			//       if (res.code == 1) {
			//         self.$message(res.msg);
			//       }
			//       self.$router.push("/technician/technicianlist/index");
			//     })
			//     .catch(error => {
			//       self.loading = false;
			//     });
			// }
		}
	};
</script>

<style>
	.click-disabled {
	  pointer-events: none;
	}
	.text-tel {
		border: none;
		background-color: white;
		width: 120px;
	}

	.user-top {
		width: 100px;
		height: 130px;
		position: relative;
		border-radius: 10px;
		overflow: hidden;
	}

	.user-top-tag {
		color: white;
		background-color: rgba(15, 15, 15, 0.2);
		position: absolute;
		bottom: 0px;
		width: 100%;
		text-align: center;

	}

	.top-head {
		display: flex;
		align-items: center;
	}

	.tag-laber {
		flex-direction: column;
		display: flex;
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// src/views/technician/technicianlist/details.vue